import { render, staticRenderFns } from "./hoursOpen_4.vue?vue&type=template&id=4da2dcac&scoped=true&"
import script from "./hoursOpen_4.vue?vue&type=script&lang=js&"
export * from "./hoursOpen_4.vue?vue&type=script&lang=js&"
import style0 from "./hoursOpen_4.vue?vue&type=style&index=0&id=4da2dcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2dcac",
  null
  
)

export default component.exports